import {
  ScopeConfigurationLoadingState,
  ScopeConfigurationState,
} from '@app/features/scope-overview/model/scope-configuration/scope-configuration.state.model'
import { State, getScopeOverviewState } from '@app/features/scope-overview/store/reducers/index'

import { ComponentModifier } from '@app/features/company-management/models/component-modifier.model'
import { ScopeConfiguration } from '@app/core/model/scope-version'
import { createSelector } from '@ngrx/store'

const getFeatureState = createSelector(
  getScopeOverviewState,
  (state: State): ScopeConfigurationState => state.scopeConfiguration
)

const selectLoadingState = createSelector(
  getFeatureState,
  (state: ScopeConfigurationState): ScopeConfigurationLoadingState => state.loading
)

const selectLoadingSaveConfiguration = createSelector(
  selectLoadingState,
  (loadingState: ScopeConfigurationLoadingState): boolean => loadingState.saveConfiguration
)

const selectLoadingSubmitConfiguration = createSelector(
  selectLoadingState,
  (loadingState: ScopeConfigurationLoadingState): boolean => loadingState.submitConfiguration
)

const selectLoadingModifiers = createSelector(
  selectLoadingState,
  (loadingState: ScopeConfigurationLoadingState): boolean => loadingState.getModifiers
)

const selectConfiguration = createSelector(
  getFeatureState,
  (state: ScopeConfigurationState): ScopeConfiguration => state.configuration
)

const selectModifiers = createSelector(
  getFeatureState,
  (state: ScopeConfigurationState): ComponentModifier[] => state.modifiers
)

export const ScopeConfigurationSelectors = {
  selectLoadingSaveConfiguration,
  selectLoadingSubmitConfiguration,
  selectLoadingModifiers,

  selectConfiguration,
  selectModifiers,
}
